import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

// import detector from 'i18next-browser-languagedetector';
import EnMain from './locales/en/main.json';
import FaMain from './locales/fa/main.json';

export const defaultNS = 'main';
export const resources = {
  en: {
    main: EnMain,
  },
  fa: {
    main: FaMain,
  },
};

i18n
  // .use(detector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    defaultNS,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
